import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  constructor(private http: HttpClient) {}

  getAccountType():Observable<any>{
    return this.http.get(environment.Server_URL+'/get-type-user');
  }

  getUserId():Observable<any>{
    return this.http.get(environment.Server_URL+'/get-id-user');
  }
}
